// Durées d'expiration disponibles selon le type d'utilisateur (source de vérité = backend).
// Anonyme : 10m/1h/4h (défaut 1h) · Free connecté : +24h · Payant : jusqu'à ent.max_secret_expiration (30j max).
import i18n, { normalizeLang } from "../i18n";

export const EXP_KEYS = ["10m", "1h", "4h", "24h", "7d", "30d"];

// Libellé localisé d'une durée (ns common -> exp.<key>). Résolu au moment de l'appel (rendu)
// pour refléter la langue active sans table figée.
export const expLabel = (key) => i18n.t(`exp.${key}`, { ns: "common", lng: normalizeLang(i18n.language) });

export const EXP_ALL = EXP_KEYS.map((key) => ({ key, get label() { return expLabel(key); } }));

const ANON_KEYS = ["10m", "1h", "4h"];
const FREE_KEYS = ["10m", "1h", "4h", "24h"];

// { user, isPaid, maxSecretExpiration } -> liste { key, label }
export function expirationOptions({ user, isPaid, maxSecretExpiration }) {
  const build = (keys) => keys.map((key) => ({ key, label: expLabel(key) }));
  if (!user) return build(ANON_KEYS);
  if (isPaid) {
    const idx = EXP_KEYS.findIndex((k) => k === maxSecretExpiration);
    return build(idx >= 0 ? EXP_KEYS.slice(0, idx + 1) : EXP_KEYS);
  }
  return build(FREE_KEYS);
}

export const DEFAULT_EXPIRATION_ANON = "1h";
